const defaultJsonCommandExtractorOptions = {
    nonJsonBehavior: 'ignore',
    terminators: ['\r', '\n'],
};
export function createJsonCommandExtractor(options) {
    var _a, _b;
    const nonJsonBehavior = (_a = options === null || options === void 0 ? void 0 : options.nonJsonBehavior) !== null && _a !== void 0 ? _a : defaultJsonCommandExtractorOptions.nonJsonBehavior;
    const terminators = (_b = options === null || options === void 0 ? void 0 : options.terminators) !== null && _b !== void 0 ? _b : defaultJsonCommandExtractorOptions.terminators;
    const terminatorsPlusBracket = [...terminators, '{'];
    return (buffer) => {
        while (buffer.length > 0) {
            buffer = removeLeadingTerminators(buffer, terminators);
            if (buffer.length === 0)
                return undefined;
            if (buffer[0] === '{')
                return extractJson(buffer);
            const nonJsonResult = extractTerminatedCommand(buffer, terminatorsPlusBracket);
            if (nonJsonResult === undefined)
                return undefined;
            if (nonJsonBehavior === 'extract')
                return nonJsonResult;
            buffer = nonJsonResult.buffer;
            buffer = removeLeadingTerminators(buffer, terminators);
        }
        return undefined;
    };
}
function extractJson(buffer) {
    if (buffer[0] !== '{')
        return undefined;
    let depth = 1;
    let n = 1;
    let inQuote = false;
    let escaped = false;
    while (n < buffer.length) {
        const ch = buffer[n];
        if (inQuote) {
            if (escaped) {
                escaped = false;
            }
            else {
                if (ch === '"') {
                    inQuote = false;
                }
                else if (ch === '\\') {
                    escaped = true;
                }
            }
        }
        else {
            if (ch === '{') {
                depth++;
            }
            else if (ch === '}') {
                depth--;
                if (depth === 0) {
                    return { command: buffer.slice(0, n + 1), buffer: buffer.substr(n + 1) };
                }
            }
        }
        n++;
    }
    return undefined;
}
function extractTerminatedCommand(buffer, terminators) {
    const allowEmptyCommands = false;
    let command = '';
    for (let i = 0; i < buffer.length; i++) {
        const c = buffer.charAt(i);
        if (terminators.includes(c)) {
            if (command.length > 0 || allowEmptyCommands) {
                return { command, buffer: buffer.slice(i) }; // leave terminator, could be "{"
            }
        }
        else {
            command += c;
        }
    }
    return undefined;
}
export function jsonParser(command) {
    try {
        const json = JSON.parse(command);
        return json;
    }
    catch (_a) {
        return undefined;
    }
}
function removeLeadingTerminators(buffer, terminators) {
    let n = 0;
    while (n < buffer.length && terminators.includes(buffer[n]))
        n++;
    if (n > 0)
        buffer = buffer.slice(n);
    return buffer;
}
